module.exports = __webpack_public_path__ + "static/img/newArrivals@2x.6451aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/newArrivals@2x.png
// module id = QK4n
// module chunks = 1